function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.234375,23.90625 C19.453125,23.90625 19.6640625,23.8203125 19.8515625,23.640625 L25,18.4921875 C25.1796875,18.3203125 25.28125,18.0859375 25.28125,17.8515625 C25.28125,17.609375 25.1796875,17.375 25,17.203125 L19.8671875,12.0703125 C19.6640625,11.875 19.453125,11.7890625 19.234375,11.7890625 C18.734375,11.7890625 18.375,12.140625 18.375,12.6171875 C18.375,12.8671875 18.4765625,13.078125 18.6328125,13.234375 L20.390625,15.015625 L22.65625,17.0859375 L20.84375,16.9765625 L11.375,16.9765625 C10.8515625,16.9765625 10.4921875,17.3359375 10.4921875,17.8515625 C10.4921875,18.359375 10.8515625,18.71875 11.375,18.71875 L20.84375,18.71875 L22.65625,18.609375 L20.390625,20.6796875 L18.6328125,22.4609375 C18.4765625,22.6171875 18.375,22.828125 18.375,23.078125 C18.375,23.5546875 18.734375,23.90625 19.234375,23.90625 Z",
  fill: "#3C4043",
  fillRule: "nonzero"
}));

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.0a0c2fc8.svg";
export { ForwardRef as ReactComponent };